'use strict';

var React = require('react');
var HCAvatar = require('../Avatar/HCAvatar.js');
var LocalOffer = require('../../node_modules/@material-ui/icons/LocalOffer.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var ListItemIcon = require('../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');
var ListItem = require('../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');
var ListItemText = require('../../node_modules/@material-ui/core/esm/ListItemText/ListItemText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles() {
  return {
    avatar: {
      position: 'relative',
      right: 4,
      marginRight: -6,
      width: 30,
      height: 30
    },
    tag: {
      fill: "#bdbdbd"
    }
  };
};

var TagSelectionListItem = function TagSelectionListItem(_ref) {
  var tag = _ref.tag,
      classes = _ref.classes,
      isPro = _ref.isPro;

  var renderProAvatar = function renderProAvatar() {
    var avatarUrl = tag.avatar,
        firstName = tag.first_name,
        lastName = tag.last_name;
    return React__default["default"].createElement(HCAvatar, {
      avatarUrl: avatarUrl,
      firstName: firstName,
      lastName: lastName,
      className: classes.avatar
    });
  };

  var renderTagIcon = function renderTagIcon() {
    return React__default["default"].createElement(LocalOffer, {
      className: classes.tag
    });
  };

  var getTags = function getTags() {
    var tags = tag.tags;
    var tagsText = tags.join(", ");
    return tagsText;
  };

  var avatar = isPro ? renderProAvatar() : renderTagIcon();
  var secondaryText = isPro ? getTags() : '';
  return React__default["default"].createElement(ListItem["default"], {
    className: classes.itemPadding
  }, React__default["default"].createElement(ListItemIcon["default"], null, avatar), React__default["default"].createElement(ListItemText["default"], {
    primary: tag.name,
    secondary: secondaryText
  }));
};

var TagSelectionListItem$1 = withStyles(styles)(TagSelectionListItem);

module.exports = TagSelectionListItem$1;
